module.exports = __webpack_public_path__ + "static/img/ent-detail-70.5839790.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-70.jpg
// module id = fQ7d
// module chunks = 51